import React from 'react';

export default () => {
    return (
        <svg version="1.1" style={{ display: 'none' }}>
            <symbol id="icon-chevron-thin-up" viewBox="0 0 20 20">
                <path d="M2.582 13.891c-0.272 0.268-0.709 0.268-0.979 0s-0.271-0.701 0-0.969l7.908-7.83c0.27-0.268 0.707-0.268 0.979 0l7.908 7.83c0.27 0.268 0.27 0.701 0 0.969s-0.709 0.268-0.978 0l-7.42-7.141-7.418 7.141z"></path>
            </symbol>
            <symbol id="icon-chevron-thin-down" viewBox="0 0 20 20">
                <path d="M17.418 6.109c0.272-0.268 0.709-0.268 0.979 0s0.271 0.701 0 0.969l-7.908 7.83c-0.27 0.268-0.707 0.268-0.979 0l-7.908-7.83c-0.27-0.268-0.27-0.701 0-0.969s0.709-0.268 0.979 0l7.419 7.141 7.418-7.141z"></path>
            </symbol>
        </svg>
    );
};


// WEBPACK FOOTER //
// ./src/components/SVGIcons.js